import { FormControl, FormGroup } from '@angular/forms';
import { FundProductInterface } from '@spa/api';
import { IUpdateProductStatusControls, UpdateProductStatusControls } from '../../../../../assets/descriptors';
import { BaseValidationFrom } from '../base-validation.form';

export class UpdateProductStatusForm extends BaseValidationFrom<IUpdateProductStatusControls> {
    initForm(): void {
        this.form = new FormGroup({});
        this.controls = UpdateProductStatusControls();

        Object.keys(this.controls).forEach(key => {
            const control = this.controls[key];

            this.form.addControl(control.name, new FormControl(control.value, control.validators));
        });
    }

    updateFormValues(product: FundProductInterface) {
        Object.keys(this.controls).forEach(key => {
            const control = this.controls[key];
            const formControl = this.form.controls[key];

            if (product.hasOwnProperty(key)) {
                control.value = product[key];
                formControl.setValue(control.value);
            }
            else {
                control.value = null;
                formControl.setValue(null);
            }
        });
    }
}
